import React from 'react';

const ContactMap: React.FC = () => {
    return (
        <div>
            <iframe title='Find Location' src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7379.795974628316!2d91.80011407006516!3d22.357480415727547!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30acd8a64095dfd3%3A0x5015cc5bcb6905d9!2sChattogram!5e0!3m2!1sen!2sbd!4v1645199641709!5m2!1sen!2sbd" width="100%" height="650px" style={{ border: 0, margin: "60px 0" }} loading="lazy"></iframe>
        </div>
    );
};

export default ContactMap;